<script>
    export let content;
    export let imageData;
    export let index;
    export let originalImage;

    //console.log(imageData);
</script>

<div class="lg:flex-1 m-6" data-aos="fade" data-aos-delay="{index*600}">
    {#if originalImage.indexOf('animated.gif') !== -1}
        <img 
            src="{originalImage}" 
            class="rounded" 
            alt=""
        >    
    {:else}
        <img 
            src="{imageData.src}" 
            srcset="{imageData.srcset}"
            sizes="100vw"
            class="rounded" 
            alt=""
        >
    {/if}
    <div class="m-4 mb-12 lg:m-0 lg:mt-4 text-lg">
        {@html content}
    </div>
</div>